



















































import isMobile from 'piramis-js-utils/lib/isMobile'
import { Component, Emit, Prop } from 'vue-property-decorator'

import { VueComponent } from '../../../../../../../../../../shared/types/VueComponent'
import { PlaceholdersOnes } from '../../../../../../../../../Editor/components/Toolbar/types'
import { AvailableButtonsTypes } from '../../../../../../../../../NewMessageEditors/NewMessageEditorWithMedia/ButtonsConstructor/logic/types'
import { PinMessageParts } from '../../../../../../../../../NewMessageEditors/NewMultiMessageEditorWithMedia/types'
import { UseFields } from '../../../../../../../../../Pi'
import MultiMessageEditorWithMediaInput from '../../../../../../../../../Pi/fields/NewMultiMessageEditorWithMediaInput/MultiMessageEditorWithMediaInput.vue'
import { FieldData } from '../../../../../../../../../Pi/types'
import CustomEditor from '../../../../../../Editor/CustomEditor'
import ProxySendMessageAction from '../../../logic/Proxy/actions/ProxySendMessageAction'
import ProxyTypingAction from '../../../logic/Proxy/actions/ProxyTypingAction'
import { SendMessageNode } from '../../../logic/SendMessageNode'

@Component({
  components: {
    MultiMessageEditorWithMediaInput,
  },
  data() {
    return {
      isMobile,
      PinMessageParts,
    }
  }
})
export default class MessageAction extends UseFields {
  @Prop() action!: ProxySendMessageAction

  @Prop() typingAction!: ProxyTypingAction | null

  @Prop() availableButtonsTypes!: AvailableButtonsTypes

  @Prop() buttonsHelpView!: VueComponent | string

  @Prop() placeholders!: PlaceholdersOnes

  @Prop() board!: string

  @Prop() node!: SendMessageNode

  @Prop() editor!: CustomEditor

  changeMessageHandler(arg: FieldData): FieldData {
    arg.setter = (val) => this.action.changeMessage(val, this.node, this.editor)
    return arg
  }

  @Emit()
  switchTyping(): this {
    return this
  }
}
